// import page from "@/app/advertise-with-us/page";

import { FeedbackPayload, NewsletterSubscriptionPayload, TrackICSPayload } from "@/types/common";
import { buildHeaders, getApiBaseUrl } from "@/utils/getApiBaseUrl";

// import { SessionUser } from "@/types/common";

// import RedisService from './redis';
// const revalidate = 30;
export const pageService = {

  getBaseUrl: (host?: string) => {
    let API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || '';

    if (host) {
      if (host.startsWith('in.')) {
        API_BASE_URL = "https://in-api.thinkry.tech";
      } else if (host.startsWith('anz.')) {
        API_BASE_URL = "https://anz-api.thinkry.tech";
      }
    } else if (typeof window !== "undefined") {
      const hostname = window.location.hostname;
      if (hostname.startsWith('in.')) {
        API_BASE_URL = "https://in-api.thinkry.tech";
      } else if (hostname.startsWith('anz.')) {
        API_BASE_URL = "https://anz-api.thinkry.tech";
      }
    }
    return API_BASE_URL;
  },

  getTopicsBySlug: async (slug: string, host?: string,isExternal:boolean=false) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host,isExternal) || pageService.getBaseUrl(host)}/api/topic/${slug}`, {
        headers: buildHeaders('', 'getTopicsBySlug', host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching topics:', error);
      return null;
    }
  },

  getTopics: async (host?: string,isExternal:boolean=false,isAll:number=0) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host,isExternal) || pageService.getBaseUrl(host)}/api/topic?isAll=${isAll}`, {
        headers: buildHeaders('', 'getTopics', host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching topics:', error);
      return null;
    }
  },

  getAuthors: async (page: number = 1, limit: number = 10, sortBy: string = "a-z", isAll?: number, host?: string) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/author?page=${page}&limit=${limit}&sortBy=${sortBy}${isAll ? `&isAll=${isAll}` : ""}`, {
        headers: buildHeaders('', 'getAuthors', host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching authors:', error);
      return null;
    }
  },

  getAuthorStories: async (slug: string,isExternal:boolean=false, page: number = 1, limit: number = 10, host?: string) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host,isExternal) || pageService.getBaseUrl(host)}/api/author/${slug}/stories?page=${page}&limit=${limit}`, {
        headers: buildHeaders('', 'getAuthorStories', host),
        cache:'no-store',
          next: { revalidate: 0 }// Cache for 30 seconds
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching author:', error);
      return null;
    }
  },
  getAuthor: async (slug: string, host?: string) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/author/${slug}`, {
        headers: buildHeaders('', 'getAuthor', host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching author:', error);
      return null;
    }
  },
  getPageData: async (slug: string, host?: string) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/page?slug=${slug}`, {
        headers: buildHeaders('', 'getPageData', host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      // await RedisService.set(slug, JSON.stringify(data), 60);
      return data;
    } catch (error) {
      console.error('Error in getPageData:', error);
      return null;
    }
  },

  getPageSEO: async (slug: string, host?: string,isExternal:boolean=false) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host,isExternal) || pageService.getBaseUrl(host)}/api/page/get-seo?slug=${slug}`, {
        headers: buildHeaders('', 'getPageSEO', host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      // await RedisService.set(slug, JSON.stringify(data), 60);
      return data;
    } catch (error) {
      console.error('Error in getPageSEO:', error);
      return null;
    }
  },

  validateSlug: async (slug: string, host?: string) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/validate-slug?slug=${slug}`, {
        headers: buildHeaders('', 'validateSlug', host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      // await RedisService.set(slug, JSON.stringify(data), 60);
      return data;
    } catch (error) {
      console.error('Error in validateSlug:', error);
      return null;
    }
  },

  getSubCategories: async (category: string, host?: string) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/subcategories/${category}`, {
        headers: buildHeaders('', 'getSubCategories', host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const subcategories = await response.json();

      // await RedisService.set(`subcategories-${category}`, JSON.stringify(subcategories), 60);
      return subcategories;
    } catch (error) {
      console.error('Error fetching subcategories:', error);
      return [];
    }
  },
  getMenus: async (host?: string,isExternal:boolean=false) => {
    try {
      // const cachedData = await RedisService.get(`menu`);
      // if (cachedData) {
      //   return JSON.parse(cachedData);
      // }
      const response = await fetch(`${getApiBaseUrl(host,isExternal) || pageService.getBaseUrl(host)}/api/menu`, {
        headers: buildHeaders('', 'getMenus', host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const menus = await response.json();

      // await RedisService.set(`menus`, JSON.stringify(menus), 60);
      return menus;
    } catch (error) {
      console.error('Error fetching menus:', error);
      return [];
    }
  },
  getPageDataBySlug: async (slug: string, host?: string,isExternal:boolean=false) => {
    try {
      // console.log('isExternal=>',isExternal,slug)
      const response = await fetch(`${getApiBaseUrl(host,isExternal) || pageService.getBaseUrl(host)}/api/collection/${slug}`, {
        headers: buildHeaders('','getPageDataBySlug',host),
         next: { tags:[`${slug}`],revalidate: 900 },
        cache:'no-store',// Cache for 30 seconds
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },
  getBRODataBySlug: async (slug: string, host?: string,isExternal:boolean=false) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host,isExternal) || pageService.getBaseUrl(host)}/api/brand/${slug}`, {
        headers: buildHeaders('','getBRODataBySlug',host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },


  getHotTopics: async (host?: string) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/hot-topics-appointments/topics`, {
        headers: buildHeaders('','getHotTopics',host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },
  getPodcasts: async (host?: string,isExternal:boolean=false) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host,isExternal) || pageService.getBaseUrl(host)}/api/podcast`, {
        headers: buildHeaders('','getPodcasts',host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      
      // console.log("API response status:", response.status);
      // console.log("API response headers:", Object.fromEntries(response.headers.entries()) as Record<string, string>);
      
      const data = await response.json();
      // console.log("API response data:", data);
      
      return data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },
  getPodcastBySlug: async (season_slug: string, episode_slug: string, host?: string,isExternal:boolean=false) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host,isExternal) || pageService.getBaseUrl(host)}/api/podcast/${season_slug}/${episode_slug}`, {
        headers: buildHeaders('','getPodcastBySlug',host),
        cache:'no-store',
          next: { revalidate: 0 }
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },
  getMorePodcasts: async (slug: string, host?: string) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/podcast/more-podcasts/${slug}`, {
        headers: buildHeaders('','getMorePodcasts',host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },
  // getMoreReads: async (host?: string) => {
  //   try {
  //     console.log(pageService.getBaseUrl(host), "process.env.NEXT_PUBLIC_API_BASE_URL");
  //     const response = await fetch(`${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/podcast/more-reads`, {
  //       cache:'no-store',
          // next: { revalidate: 0 } // Cache for 30 seconds
  //     });
  //     const data = await response.json();
  //     return data;
  //   } catch (error) {
  //     console.error('Error fetching page data:', error);
  //     return null;
  //   }
  // },


  getAppointments: async (host?: string) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/hot-topics-appointments/appointments`, {
        headers: buildHeaders('','getAppointments',host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },
  getProducts: async (pageSize?: string) => {
    try {
      const response = await fetch(`https://api-prod.pmoctopus.ai/api/email-sender/get-prod?serach=1&isAll=0&pageSize=${pageSize}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // ...buildHeaders(),
          },
          body: JSON.stringify({
            serach: 1,
            isAll: 0,
            pageSize: pageSize
          }),
          cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
        });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },
  getSubCategory: async (category: string, host?: string,isExternal:boolean=false) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host,isExternal) || pageService.getBaseUrl(host)}/api/category/getsubcategory/${category}`, {
        headers: buildHeaders('','getSubCategory',host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      // console.log(data, "response getSubCategory");
      return data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },
  getSubMenu: async (category: string, menu_type: string, host?: string) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/category/getsubcategory/${category}?menu_type=${menu_type}`, {
        headers: buildHeaders('','getSubMenu',host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },
  // getEvents: async (archived?: boolean, year?: string,sortBy?: string, host?: string) => {
  //   // console.log(sortBy, "sortBy getEvents");
  //   try {
  //     const response = await fetch(`${pageService.getBaseUrl(host)}/api/event/list/${archived ? "past" : "upcoming"}?${year ? "year=" + year : ""}&${sortBy ? "sortBy=event_type&sortOrder=desc" : ""}&${sortBy ? "event_type=" +sortBy : ""}`, {
  //       cache:'no-store',
          // next: { revalidate: 0 } // Cache for 30 seconds
  //     });
  //     const data = await response.json();
  //     return data;
  //   } catch (error) {
  //     console.error('Error fetching page data:', error);
  //     return null;
  //   }
  // },

  getEvents: async (time?: string, year?: string, sortBy?: string, page: number = 1, host?: string,isExternal:boolean=false) => {
    try {

      const response = await fetch(`${getApiBaseUrl(host,isExternal) || pageService.getBaseUrl(host)}/api/event/list/${time}?${year ? "year=" + year : ""}&${sortBy ? "sortBy=event_type&sortOrder=desc" : ""}&${sortBy ? "event_type=" + sortBy : ""}&page=${page}`, {
        headers: buildHeaders('','getEvents',host),
        cache:'no-store',
          next: { revalidate: 0 }
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },
  getEventBySlug: async (slug: string, host?: string,isExternal:boolean=false) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host,isExternal) || pageService.getBaseUrl(host)}/api/event/${slug}`, {
        headers: buildHeaders('','getEventBySlug',host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },
  getBrands: async (host?: string) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/brand`, {
        headers: buildHeaders('','getBrands',host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },


  getTagsCategoryBasedOnPostType: async (postIds: string, host?: string) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/collection/getDetailByPostID?post_id=${postIds}`,
        {
          headers: buildHeaders('','getTagsCategoryBasedOnPostType',host),
          cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
        }
      );

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching CategoryTags data:', error);
      return null;
    }
  },

  getBrangTagSlug: async (host?: string,isExternal:boolean=false) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host,isExternal) || pageService.getBaseUrl(host)}/api/brand/all/get-brand-tags`,
        {
          headers: buildHeaders('','getBrangTagSlug',host),
          cache:'no-store',
          next: { revalidate: 0 }, // Cache for 30 seconds
        });
      const data = await response.json();
      return data?.data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },

  getTagsCategoryBasedOnSearchKeyword: async (postIds: string, host?: string, recaptchaToken?: string | null) => {
    try {
      let apiUrl = `${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/collection/getDetailByPost/search?${postIds}`;
      
      if (recaptchaToken) {
        apiUrl += `&recaptchaToken=${encodeURIComponent(recaptchaToken)}`;
      }
      
      const response = await fetch(apiUrl,
        {
          headers: buildHeaders('','getTagsCategoryBasedOnSearchKeyword',host),
          cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
        }
      );

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching CategoryTags data:', error);
      return null;
    }
  },

  getSearchKeywordBasedSuggestionList: async (search_txt: string, host?: string, recaptchaToken?: string | null) => {
    try {
      let apiUrl = `${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/article/suggest-list?search_txt=${search_txt}&pageNo=1&pageSize=20`;
      
      if (recaptchaToken) {
        apiUrl += `&recaptchaToken=${recaptchaToken}`;
      }
      
      const response = await fetch(apiUrl,
        {
          headers: buildHeaders('','getSearchKeywordBasedSuggestionList',host),
          cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
        }
      );

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching CategoryTags data:', error);
      return null;
    }
  },
  getCategoryList: async (slug: string, host?: string) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/category?${slug}`, {
        headers: buildHeaders('','getCategoryList',host),
        cache:'no-store',
        next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },
  getPostTypeList: async (slug: string, host?: string) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/post-type?${slug}`, {
        headers: buildHeaders('','getPostTypeList',host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },
  getTagList: async (slug: string, host?: string) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/tag?${slug}`, {
        headers: buildHeaders('','getTagList',host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },
  getBrandList: async (slug: string, host?: string) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/brand?${slug}`, {
        headers: buildHeaders('','getBrandList',host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },

  getArticleListSerach: async (slug: string, host?: string, recaptchaToken?: string | null) => {
    try {
      let url = `${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/article?${slug}`;
      if (recaptchaToken) {
        url += `&recaptchaToken=${encodeURIComponent(recaptchaToken)}`;
      }
      const response = await fetch(url, {
        headers: buildHeaders('','getArticleListSerach',host),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },

  subscribeNewsLetter: async (payload?: NewsletterSubscriptionPayload, host?: string) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/auth/subscribe-newsletter`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...buildHeaders('','subscribeNewsLetter',host),
          },
          body: JSON.stringify(payload),
          cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
        });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching subscribeNewsLetter data:', error);
      return null;
    }
  },

  saveEventBySubscriber: async (eventId: number, token: string) => {

    try {
      const response = await fetch(
        `${getApiBaseUrl() || process.env.NEXT_PUBLIC_API_BASE_URL}/api/event/save-event`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${token}`,
            ...buildHeaders(token,'saveEventBySubscriber',''),
          },
          body: JSON.stringify({
            fk_event_id: eventId,
          }),
          cache:'no-store',
          next: { revalidate: 0 }, // Cache for 30 seconds
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error submitting saveEventBySubscriber form:", error);
      throw error; // Re-throw to handle in the calling component
    }
  },
  getSaveEventBySubscriber: async ({
    eventId,
    token,
    pageNo,
    pageSize
  }: {
    eventId?: number;
    token: string;
    pageNo?: number;
    pageSize?: number;
  }) => {

    try {
      const response = await fetch(
        `${getApiBaseUrl() || process.env.NEXT_PUBLIC_API_BASE_URL}/api/event/get-save-event?fk_event_id=${eventId}&pageNo=${pageNo}&pageSize=${pageSize}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${token}`,
            ...buildHeaders(token,'getSaveEventBySubscriber',''),
          },
          cache:'no-store',
          next: { revalidate: 0 }, // Cache for 30 seconds
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error submitting getSaveEventBySubscriber form:", error);
      throw error; // Re-throw to handle in the calling component
    }
  },

  getEventsFilterBy: async () => {
    try {
      const response = await fetch(`${getApiBaseUrl() || process.env.NEXT_PUBLIC_API_BASE_URL}/api/event/get-event-group?isAll=0`, {
        headers: buildHeaders('','getEventsFilterBy',''),
        cache:'no-store',
          next: { revalidate: 0 },
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching page data:', error);
      return null;
    }
  },
  createFeedback: async (payload: FeedbackPayload, host?: string) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...buildHeaders('', 'createFeedback', host),
        },
        body: JSON.stringify(payload),
        cache:'no-store',
          next: { revalidate: 0 } // Cache for 30 seconds
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error creating feedback:', error);
      return null;
    }
  },
  trackICS: async (payload: TrackICSPayload, token?: string, host?: string) => {
    try {
      const response = await fetch(`${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/api/track-ics`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...buildHeaders(token || '', 'trackICS', host),
        },
        body: JSON.stringify(payload),
        cache:'no-store',
          next: { revalidate: 0 },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    const data = await response.json();
    return data;
  } catch (error) {
      console.error('Error tracking ICS:', error);
      return null;
    }
  },

  unsubscribe: async (payload: { token: string }, host?: string) => {
    try {
      const response = await fetch(
        `${getApiBaseUrl(host) || pageService.getBaseUrl(host)}/crm/unsubscribe?token=${payload.token}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            ...buildHeaders('', 'unsubscribed', host),
          },
        }
      );
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Failed to unsubscribe');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error in unsubscribe API:", error);
      throw error;
    }
  }
};